import React from 'react';
import CaseStudyTemplate from './CaseStudyTemplate';

export default function CaseStudyWiley() {
  const summary = (
    <p>This is where your summary content will go. Replace this text with your project overview and key outcomes.</p>
  );

  const challenge = (
    <p>Describe the main problem or challenge that needed to be solved in this project.</p>
  );

  const roleAndApproach = (
    <p>Explain your specific role in the project and the methodology or approach you used.</p>
  );

  const findings = (
    <p>Share the key insights, discoveries, or research findings from your work on this project.</p>
  );

  const outcomes = (
    <p>Describe the results and impact of your work - what changed or improved as a result of this project.</p>
  );

  const keyDeliverables = (
    <p>List the main outputs, documents, designs, or solutions you delivered for this project.</p>
  );

  const lessonsLearned = (
    <p>Reflect on what you learned from this project and how it influenced your future work.</p>
  );

  return (
    <CaseStudyTemplate
      clientName="Wiley"
      title="Customer Journey Mapping and Training"
      subtitle="Building a journey mapping process for improved understanding of customer behaviors"
      heroImage={require('../assets/cjm2.png')}
      heroImageAlt="Wiley Platform"
      summary={summary}
      challenge={challenge}
      roleAndApproach={roleAndApproach}
      findings={findings}
      outcomes={outcomes}
      keyDeliverables={keyDeliverables}
      lessonsLearned={lessonsLearned}
    />
  );
}